module.exports = __webpack_public_path__ + "static/media/github.192a6620.svg";